import { colors, createMuiTheme } from "@material-ui/core";
export var theme = createMuiTheme({
    palette: {
        primary: {
            main: "#5278FF"
        },
        secondary: {
            main: "#1B0406"
        },
        error: {
            main: colors.red.A200
        },
        text: {
            primary: "#1B0406",
            secondary: "#76686A",
            hint: "#A49B9B"
        },
        background: {
            default: "#FFF7F5"
        }
    },
    typography: {
        fontFamily: "'Area Normal', sans-serif",
        fontSize: 13,
        body1: {
            fontSize: 13,
            lineHeight: "18px",
            fontWeight: 700
        },
        body2: {
            fontSize: 13,
            lineHeight: "18px",
            fontWeight: 400
        },
        h5: {
            fontFamily: "'Transducer VF', sans-serif",
            fontWeight: 700,
            textTransform: "uppercase",
            fontSize: 34,
            lineHeight: 1
        }
    },
    shape: {
        borderRadius: 15
    },
    overrides: {
        MuiInput: {
            root: {
                backgroundColor: "#EEF2FF",
                borderRadius: 60,
                height: 50,
                padding: "0 20px",
                fontSize: 13,
                fontWeight: 700,
                color: "#1B0406",
                "&$focused": {
                    backgroundColor: "#E6EBFF"
                },
                "&$disabled": {
                    backgroundColor: "#F4F2F3"
                }
            },
            underline: {
                "&:before": { display: "none" },
                "&:after": { display: "none" },
                "&:hover:not($disabled):before": { display: "none" }
            },
            input: {
                padding: "16px 0",
                "&::placeholder": {
                    color: "#76686A",
                    fontWeight: 400,
                    opacity: 1
                }
            }
        },
        MuiInputLabel: {
            root: {
                display: "none"
            }
        },
        MuiFormControl: {
            marginDense: {
                marginTop: 0,
                marginBottom: 0
            }
        },
        MuiButton: {
            containedPrimary: {
                backgroundColor: "#1B0406",
                color: "#FFFFFF",
                fontFamily: "'Transducer VF', sans-serif",
                fontWeight: 700,
                fontSize: 18,
                textTransform: "uppercase",
                borderRadius: 15,
                height: 50,
                boxShadow: "none",
                "&:hover": {
                    backgroundColor: "#2D1012",
                    boxShadow: "none"
                }
            }
        },
        MuiIconButton: {
            root: {
                color: "#76686A",
                padding: 8
            }
        }
    }
});
